import React from "react";
import { ArrowUp, Heart } from "lucide-react";
import { CONTACT } from "../data/portfolioData";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="relative bg-slate-100/80 border-t border-slate-200 pt-12 pb-8 overflow-hidden">
      {/* Animated Gradient Divider */}
      <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-indigo-500 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 pb-8 border-b border-slate-200">
          {/* Brand */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-tr from-indigo-600 to-purple-600 flex items-center justify-center font-black text-white text-sm shadow-md">
              RS
            </div>
            <div>
              <div className="font-bold text-slate-900 text-sm flex items-center gap-2">
                {CONTACT.name}
                <span className="text-[10px] font-mono px-2 py-0.5 rounded bg-indigo-100 text-indigo-700 border border-indigo-200">
                  DevOps & Cloud
                </span>
              </div>
              <p className="text-xs text-slate-500 font-mono mt-0.5">
                {CONTACT.title}
              </p>
            </div>
          </div>

          {/* Quick Footer Links */}
          <div className="flex flex-wrap items-center gap-6 text-xs font-semibold text-slate-600">
            <a href="#about" className="hover:text-indigo-600 transition">About</a>
            <a href="#skills" className="hover:text-indigo-600 transition">Skills</a>
            <a href="#experience" className="hover:text-indigo-600 transition">Experience</a>
            <a href="#projects" className="hover:text-indigo-600 transition">Projects</a>
            <a href="#certificates" className="hover:text-indigo-600 transition">Certificates</a>
            <a href="#education" className="hover:text-indigo-600 transition">Education</a>
            <a href="#contact" className="hover:text-indigo-600 transition">Contact</a>
          </div>

          {/* Back to Top CTA */}
          <button
            onClick={scrollToTop}
            aria-label="Back to top"
            className="p-3 rounded-xl bg-white hover:bg-slate-50 text-slate-700 hover:text-indigo-600 border border-slate-200 transition-all duration-300 hover:scale-105 flex items-center gap-2 text-xs font-mono shadow-sm"
          >
            <span>Back to Top</span>
            <ArrowUp size={16} className="text-indigo-600" />
          </button>
        </div>

        {/* Copyright & Sign-off */}
        <div className="flex flex-col sm:flex-row items-center justify-between text-xs font-mono text-slate-500 gap-4">
          <div>
            © {new Date().getFullYear()} {CONTACT.name}. All rights reserved.
          </div>
          <div className="flex items-center gap-1.5">
            <span>Built with React, Framer Motion &</span>
            <Heart size={13} className="text-rose-500 fill-rose-500 animate-pulse" />
            <span>DevOps Precision</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
